import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { GenericLinkModule, MediaModule } from '@spartacus/storefront';

import { KnBrResponsiveBannerComponent } from './kn-br-banner.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        GenericLinkModule,
        MediaModule,
        ConfigModule.withConfig({
            cmsComponents: {
                SimpleResponsiveBannerComponent: {
                    component: KnBrResponsiveBannerComponent,
                },
                BannerComponent: {
                    component: KnBrResponsiveBannerComponent,
                },
                SimpleBannerComponent: {
                    component: KnBrResponsiveBannerComponent,
                },
            },
        } as CmsConfig),
        KnBrResponsiveBannerComponent,
    ],
    exports: [KnBrResponsiveBannerComponent]
})
export class KnBrBannerModule {}
